import { baseApi } from '@store/rtk/base';
import { createQueryString } from '@apiService/ApiHelper';
import { decryptPayload } from '@helper/index';

// define a service using a base URL and expected endpoints
export const movieListApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (builder) => ({
    // get upcoming api endpoint
    getUpcoming: builder.query({
      providesTags: ['UPCOMING'],

      // api endpoint query setup
      query: (QueryArg = { limit: 1000, currentPage: 1 }) => {
        let payload = { ...QueryArg };
        // let cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
        // if (cinema) payload.cinema_id = cinema.cinema_id;
        //
        // let city = JSON.parse(localStorage.getItem(`selected_city`));
        // if (city) payload.city_id = city?.city_id;

        return {
          url: `api/cinema/admin/upcoming-show-list${createQueryString(
            payload,
          )}&rtk=true`,

          // query responses validation for success or failure, our API always returns a 200, but sets an `status` property for success or failure
          validateStatus: (response, result) => {
            return response?.status === 200 && result?.status === true;
          },
        };
      },

      // customizing query responses with transformResponse
      transformResponse: (data, meta, arg) => {
        const keys = {
          key: process.env.REACT_APP_CRYPTO_KEY,
          iv: process.env.REACT_APP_CRYPTO_IV,
        };

        let decryptedPayload = decryptPayload(data.encryptedData, keys);
        let parsedData = decryptedPayload;

        try {
          parsedData = JSON.parse(decryptedPayload);
        } catch (error) {
          console.log('error in rtk parsing', error);
          parsedData = decryptedPayload;
        }
        data = parsedData;
        //Getting Reverse Earlier then Added Upcoming Movies Sort Order need to comment this line for that
        // data.Records.data = data?.Records?.data?.reverse() ?? [];

        data.Records.data = data?.Records?.data ?? [];

        data.Records.data = data?.Records?.data?.filter((item) => {
          if (!item.hasOwnProperty('now_showing_count')) return true;

          return item?.now_showing_count === 0 || item?.now_showing_count === null;
        });

        // Sort by original_release_date ascending
        data.Records.data.sort(
          (a, b) =>
            new Date(a.original_release_date) - new Date(b.original_release_date),
        );
        return data?.Records ?? [];
      },
    }),

    // get ondemand api endpoint
    getOnDemand: builder.query({
      providesTags: ['ONDEMAND'],

      // api endpoint query setup
      query: (
        QueryArg = {
          limit: 1000,
          currentPage: 1,
          isUserLogged: localStorage.getItem('user') ? 'Y' : 'N',
        },
      ) => {
        let payload = { ...QueryArg };
        let cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
        if (cinema) payload.cinema_id = cinema.cinema_id;

        let city = JSON.parse(localStorage.getItem(`selected_city`));
        if (city) payload.city_id = city?.city_id;

        payload.onDemand = true;
        // payload.isUserLogged = localStorage.getItem("user") ? "Y" : "N";

        return {
          url: `api/cinema/admin/now-showing-list${createQueryString(
            payload,
          )}&rtk=true`,

          // query responses validation for success or failure, our API always returns a 200, but sets an `status` property for success or failure
          validateStatus: (response, result) => {
            return response?.status === 200 && result?.status === true;
          },
        };
      },

      // customizing query responses with transformResponse
      transformResponse: (data, meta, arg) => {
        const keys = {
          key: process.env.REACT_APP_CRYPTO_KEY,
          iv: process.env.REACT_APP_CRYPTO_IV,
        };

        let decryptedPayload = decryptPayload(data.encryptedData, keys);
        let parsedData = decryptedPayload;

        try {
          parsedData = JSON.parse(decryptedPayload);
        } catch (error) {
          console.log('error in rtk parsing', error);
          parsedData = decryptedPayload;
        }
        data = parsedData;

        return data?.Records ?? [];
      },
    }),

    // get now showing api endpoint
    getNowShowing: builder.query({
      providesTags: ['NOWSHOWING'],

      // api endpoint query setup
      query: (QueryArg = { limit: 1000, currentPage: 1 }) => {
        let payload = { ...QueryArg };
        let cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
        if (cinema) payload.cinema_id = cinema.cinema_id;

        let city = JSON.parse(localStorage.getItem(`selected_city`));
        if (city) payload.city_id = city?.city_id;

        if (payload.currentPage) delete payload.currentPage;
        if (payload.limit) delete payload.limit;

        return {
          url: `api/cinema/admin/now-showing-confirmed-list/bffv1${createQueryString(
            payload,
          )}`,

          // query responses validation for success or failure, our API always returns a 200, but sets an `status` property for success or failure
          validateStatus: (response, result) => {
            return response?.status === 200 && result?.status === true;
          },
        };
      },

      // customizing query responses with transformResponse
      transformResponse: (data, meta, arg) => {
        const keys = {
          key: process.env.REACT_APP_CRYPTO_KEY,
          iv: process.env.REACT_APP_CRYPTO_IV,
        };

        let decryptedPayload = decryptPayload(data.encryptedData, keys);
        let parsedData = decryptedPayload;

        try {
          parsedData = JSON.parse(decryptedPayload);
        } catch (error) {
          console.log('error in rtk parsing', error);
          parsedData = decryptedPayload;
        }
        data = parsedData;
        const uniqueTodaysScreeningMovies = {
          ...data?.Records,
          data: [
            ...new Map(
              data?.Records?.data?.map((item) => [item['movie_id'], item]),
            ).values(),
          ].sort((a, b) => {
            let comparison = (a?.m_order || 999) - (b?.m_order || 999);

            if (comparison === 0) comparison = b?.ss_count - a?.ss_count;

            // Turn your strings into dates, and then subtract them to get a value that is either negative, positive, or zero.
            if (comparison === 0)
              comparison =
                new Date(b?.mrrdr_release_date || b?.original_release_date) -
                new Date(a?.mrrdr_release_date || a?.original_release_date);

            if (comparison === 0)
              comparison = a?.movie_title?.localeCompare(
                b?.movie_title,
                undefined,
                {
                  usage: 'sort',
                  sensitivity: 'base',
                  ignorePunctuation: true,
                },
              );

            return comparison;
          }),
        };

        // console.log(
        //   uniqueTodaysScreeningMovies?.data.map(
        //     (m) =>
        //       `${m.m_order || 'm_order'}, ${m.ss_count || 'ss_count'},  ${
        //         m?.mrrdr_release_date || m?.original_release_date || 'date'
        //       },  ${m?.movie_title || 'movie_title'}, `,
        //   ),
        // );

        return uniqueTodaysScreeningMovies;
      },
    }),

    // get miniFestival api endpoint
    getMiniFestival: builder.query({
      providesTags: ['MINIFESTIVAL'],

      // api endpoint query setup
      query: (
        QueryArg = {
          currentPage: 1,
          index: null,
          category_link_name: null,
          category_id: 4,
        },
      ) => {
        let payload = { ...QueryArg };
        let cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
        if (cinema) payload.cinema_id = cinema.cinema_id;

        let city = JSON.parse(localStorage.getItem(`selected_city`));
        if (city) payload.city_id = city?.city_id;

        return {
          url: `api/cinema/get-minifestival-list${createQueryString(
            payload,
          )}&rtk=true`,

          // query responses validation for success or failure, our API always returns a 200, but sets an `status` property for success or failure
          validateStatus: (response, result) => {
            return response?.status === 200 && result?.status === true;
          },
        };
      },

      // customizing query responses with transformResponse
      transformResponse: (data, meta, arg) => {
        const keys = {
          key: process.env.REACT_APP_CRYPTO_KEY,
          iv: process.env.REACT_APP_CRYPTO_IV,
        };

        let decryptedPayload = decryptPayload(data.encryptedData, keys);
        let parsedData = decryptedPayload;

        try {
          parsedData = JSON.parse(decryptedPayload);
        } catch (error) {
          console.log('error in rtk parsing', error);
          parsedData = decryptedPayload;
        }
        data = parsedData;

        return data;
      },
    }),

    // get festivalList api endpoint
    getFestivalList: builder.query({
      providesTags: ['FESTIVALLIST'],

      // api endpoint query setup
      query: (QueryArg = { category_id: 3 }) => {
        let payload = { ...QueryArg };
        let cinema = JSON.parse(localStorage.getItem(`selected_cinema`));
        if (cinema) payload.cinema_id = cinema.cinema_id;

        let city = JSON.parse(localStorage.getItem(`selected_city`));
        if (city) payload.city_id = city?.city_id;

        return {
          url: `api/cinema/festival-list${createQueryString(payload)}&rtk=true`,

          // query responses validation for success or failure, our API always returns a 200, but sets an `status` property for success or failure
          validateStatus: (response, result) => {
            return response?.status === 200 && result?.status === true;
          },
        };
      },

      // customizing query responses with transformResponse
      transformResponse: (data, meta, arg) => {
        const keys = {
          key: process.env.REACT_APP_CRYPTO_KEY,
          iv: process.env.REACT_APP_CRYPTO_IV,
        };

        let decryptedPayload = decryptPayload(data.encryptedData, keys);
        let parsedData = decryptedPayload;

        try {
          parsedData = JSON.parse(decryptedPayload);
        } catch (error) {
          console.log('error in rtk parsing', error);
          parsedData = decryptedPayload;
        }
        data = parsedData;

        return data?.Records ?? [];
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useGetUpcomingQuery,
  useGetOnDemandQuery,
  useGetNowShowingQuery,
  useGetMiniFestivalQuery,
  useGetFestivalListQuery,
} = movieListApi;
